// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.food-image{
    width: 20%;
    height: 105px;
    object-fit: cover;
}

.UpperBox{
    /* display: flex;
    align-items: baseline;
    gap: 30px;
    justify-content: space-between;
    min-width: 197px; */
}

.TextLabel{
    color: #11192a;
    font-size: 20px;
}

.Text1{
    color: #ff1e46;
    font-size: 17px;
}

.MainBox{
    background: rgb(255, 255, 255);
    padding: 15px;
    margin: 30px;
    border-radius: 10px;
    /* display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; */
}

.Section-1{
    display: flex;
    
    align-items: baseline;
    gap: 185px;

}


.info-text {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 10px;
}

.Section-new {
    background: #fff;
    padding: 25px 16px;
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
    box-shadow: none !important;

}

.Main-box-1 {
    /* display: flex;
    justify-content: space-between;
    align-items: center; */

    display: block !important;
}



.order-info-box {
    text-align: left;
    margin-bottom: 20px;
}

.order-text-1 {
    margin: 0;
    font-size: 16px;
}

.order-text-2 {
    margin: 0;
    color: #000;
    font-weight: 600;
}

.order-info-box-right {
    text-align: right;
}

.back-btn{
    background: blue !important;
    color: #fff !important;
    margin-top: 20px !important;
}


.food-image22{
    width: 115px !important;
    height: 115px !important;
}

.detail-page-section{
    margin: 40px;
}


.back-btn-2{
    background: blue !important;
    color: #fff !important;
    margin-top: 10px !important;
    margin-bottom: 20px !important;
}

.order-text-new-description{
    font-size: 15px !important;
    margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/content/applications/Contact/ViewList.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;;;;uBAImB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB;;;0BAGsB;AAC1B;;AAEA;IACI,aAAa;;IAEb,qBAAqB;IACrB,UAAU;;AAEd;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kFAAkF;IAClF,2BAA2B;;AAE/B;;AAEA;IACI;;0BAEsB;;IAEtB,yBAAyB;AAC7B;;;;AAIA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;AAC/B;;;AAGA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;AACxB","sourcesContent":[".food-image{\n    width: 20%;\n    height: 105px;\n    object-fit: cover;\n}\n\n.UpperBox{\n    /* display: flex;\n    align-items: baseline;\n    gap: 30px;\n    justify-content: space-between;\n    min-width: 197px; */\n}\n\n.TextLabel{\n    color: #11192a;\n    font-size: 20px;\n}\n\n.Text1{\n    color: #ff1e46;\n    font-size: 17px;\n}\n\n.MainBox{\n    background: rgb(255, 255, 255);\n    padding: 15px;\n    margin: 30px;\n    border-radius: 10px;\n    /* display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center; */\n}\n\n.Section-1{\n    display: flex;\n    \n    align-items: baseline;\n    gap: 185px;\n\n}\n\n\n.info-text {\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 10px;\n}\n\n.Section-new {\n    background: #fff;\n    padding: 25px 16px;\n    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */\n    box-shadow: none !important;\n\n}\n\n.Main-box-1 {\n    /* display: flex;\n    justify-content: space-between;\n    align-items: center; */\n\n    display: block !important;\n}\n\n\n\n.order-info-box {\n    text-align: left;\n    margin-bottom: 20px;\n}\n\n.order-text-1 {\n    margin: 0;\n    font-size: 16px;\n}\n\n.order-text-2 {\n    margin: 0;\n    color: #000;\n    font-weight: 600;\n}\n\n.order-info-box-right {\n    text-align: right;\n}\n\n.back-btn{\n    background: blue !important;\n    color: #fff !important;\n    margin-top: 20px !important;\n}\n\n\n.food-image22{\n    width: 115px !important;\n    height: 115px !important;\n}\n\n.detail-page-section{\n    margin: 40px;\n}\n\n\n.back-btn-2{\n    background: blue !important;\n    color: #fff !important;\n    margin-top: 10px !important;\n    margin-bottom: 20px !important;\n}\n\n.order-text-new-description{\n    font-size: 15px !important;\n    margin: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
